import React, { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiX, FiCpu } = FiIcons;

const DemoPreviewModal = ({ demo, onClose }) => {
  const [isLoading, setIsLoading] = useState(true);
  const scrollPos = useRef(0);

  useEffect(() => {
    if (demo) {
      scrollPos.current = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollPos.current}px`;
      document.body.style.width = '100%';
      setIsLoading(true);
    } else {
      const top = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, parseInt(top || '0') * -1);
    }
    return () => {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
    };
  }, [demo]);

  if (!demo) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="modal-overlay"
        onClick={onClose}
      >
        <motion.div
          initial={{ scale: 0.98, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.98, opacity: 0 }}
          className="modal-content"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-header">
            <div className="flex items-center gap-4">
              <div className="w-10 h-10 rounded-xl bg-blue-500/10 flex items-center justify-center border border-blue-500/20">
                <SafeIcon icon={FiCpu} className="text-blue-500" />
              </div>
              <div>
                <h3 className="text-sm font-bold text-white font-display leading-tight">{demo.label}</h3>
                <p className="text-[9px] uppercase tracking-widest text-slate-500 font-black">{demo.industry}</p>
              </div>
            </div>
            
            <div className="hidden md:block text-[10px] text-slate-500 font-bold uppercase tracking-[0.2em]">
              Example page built using BPA Authority Pages framework
            </div>
            
            <button onClick={onClose} className="p-3 rounded-xl bg-white/5 border border-white/10 text-white">
              <SafeIcon icon={FiX} className="text-xl" />
            </button>
          </div>

          <div className="modal-iframe-container">
            {isLoading && (
              <div className="absolute inset-0 flex items-center justify-center bg-[#080a0d] z-10">
                <div className="w-12 h-12 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
              </div>
            )}
            <iframe
              src={demo.url}
              title={demo.label}
              className="modal-iframe"
              onLoad={() => setIsLoading(false)}
              allow="fullscreen"
            />
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default DemoPreviewModal;